import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectServiceCatalogsInStore,
  selectServiceCatalogsPageLoading,
  selectServiceCatalogsShowInitWaitingMessage,
} from '../_selectors/service-catalog.selectors';

export class ServiceCatalogsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectServiceCatalogsPageLoading));
    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectServiceCatalogsShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectServiceCatalogsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
